export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/topojson-client/src/identity.js
// module id = k+q3
// module chunks = 0